import { Button, Col, Form, Input, Row } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useLogin } from "./../hooks/HookLogin";

const onFinishFailed = errorInfo => {
    //console.log('Failed:', errorInfo);
};


const FormLogin = () => {
    const { handleSingIn } = useLogin();

    const [form] = Form.useForm();

    const onFinish = async (values) => {
        await handleSingIn(values);
    }

    return (
        <Row align="middle" justify="center">
            <Col>
                <Form
                    name="login_form"
                    form={form}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    layout="vertical"
                >
                    <Form.Item
                        label="Correo electrónico"
                        name="email"
                        rules={[
                            { required: true, message: '¡Por favor ingresa tu correo!' },
                            { whitespace: true },
                            { type: 'email', message: 'Por favor ingresa un correo electrónico válido' },
                            { pattern: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/, message: 'Por favor ingresa un correo electrónico valido' }
                        ]}
                    >
                        <Input prefix={<UserOutlined />} placeholder='Ingresa tu correo electrónico' />
                    </Form.Item>

                    <Form.Item
                        label="Contraseña"
                        name="pwd"
                        rules={[{ required: true, message: '¡Por favor ingresa tu contraseña!' }, { whitespace: true }, { min: 4, message: 'Por favor ingresa tu contraseña' }]}
                    >
                        <Input.Password prefix={<LockOutlined />} placeholder='Contraseña' />
                    </Form.Item>

                    <Form.Item label={null}>
                        <Button type="primary" block htmlType="submit">
                            Iniciar sesión
                        </Button>
                    </Form.Item>
                </Form>
            </Col>
        </Row>
    )
};
export default FormLogin;